export { FeaturedArticle } from './FeaturedArticle';
